import React from "react";
import LandingFooter from "./LandingFooter";
import "../landing.css";

/**
 * Wraps each page's content with the footer. Nav lives separately in LandingNav, rendered once
 * in LandingApp.js so it never remounts on navigation — LandingShell (and its footer) remounts
 * per page like the content does, giving a visible page-change cue while nav stays put.
 */
const LandingShell = ({ children }) => (
    <>
        {children}
        <LandingFooter />
    </>
);

export default LandingShell;
